import { Gapcursor } from '@tiptap/extensions'

export { Gapcursor } from '@tiptap/extensions'

export default Gapcursor
